const partnerEnv = require('./config/partner')
const loaderSettings = require('./config/loader')
const flowSettings = require('./config/settings')
const flowVariants = require('./config/variants')

let config = {
  ...partnerEnv,
  loader: loaderSettings,
  settings: flowSettings,
  variants: flowVariants,
  // testScreen: 'city',
  path: (i18n) => ([
    {
      path: '/chapter1',
      params: {
        title: () => i18n.t('overview:step_one')
      },
      screens: [
        {
          type: 'email',
          params: {
            collectBlackbox: true
          }
        }
      ]
    },
    {
      path: '/chapter2',
      params: {
        title: () => i18n.t('overview:step_two')
      },
      screens: [
        {
          type: 'password-animated',
          params: {
            checkBlackBoxInIovation: true
          }
        },
        { type: 'phone-number' },
        { type: 'email-validation', params: { validation: true } }
      ]
    },
    {
      path: '/chapter3',
      params: {
        title: () => i18n.t('overview:step_three'),
        noTitleScreens: ['document-uploader']
      },
      screens: [
        {
          type: 'chapter-description',
          params: {
            hideTitle: true,
            dispatchKey: 'updateUser',
            propertyName: 'hasBonus',
            currentAnswer: (store) => store.state.user.hasBonus,
            jumbotronPicture: require('static/intro-chapter.jpg'),
            header: () => i18n.t('intro:intro_chapter3_header'),
            description: () => i18n.t('intro:intro_chapter3_content'),
            toggle: () => i18n.t('intro:intro_chapter3_toggle'),
            showKeyboardOnNextScreen: true
          }
        },
        {
          type: 'open-question.bonus',
          params: {
            title: () => i18n.t('bonusCode:bonus_code'),
            placeholder: () => i18n.t('bonusCode:enter_bonus_code'),
            dispatchKey: 'updateUser',
            propertyName: 'bonus',
            currentAnswer: (store) => store.state.user.bonus,
            conditions: [{ property: 'user.hasBonus', value: true }]
          }
        },
        { type: 'full-name' },
        {
          type: 'question.gender',
          params: {
            columns: true,
            text: () => i18n.t('gender:select_gender'),
            dispatchKey: 'updateUser',
            propertyName: 'gender',
            currentAnswer: (store) => store.state.user.gender,
            answers: () => ([
              { id: 'female', label: i18n.t('gender:female') },
              { id: 'male', label: i18n.t('gender:male') }
            ])
          }
        },
        { type: 'postal-code' },
        /* not roots */
        {
          type: 'question.state',
          params: {
            list: true,
            scrollShadow: true,
            text: () => i18n.t('postalCode:select_province', { context: 'us' }),
            dispatchKey: 'updateUser',
            propertyName: 'province',
            currentAnswer: (store) => store.state.user.state,
            answers: (store) => {
              return store.state.app.country.provinces.map(p => ({
                id: p.ISOCode.slice(-2),
                label: p.name
              }))
            },
            conditions: [
              {
                property: 'user.province',
                value: false
              },
              {
                property: 'app.postalArea.streets',
                value: false
              },
              {
                property: 'app.country.code',
                value: 'US'
              }
            ]
          }
        },
        { type: 'city' },
        { type: 'street-name' },
        { type: 'house-number' },
        {
          type: 'currency-selector',
          params: {
            conditions: [
              {
                property: 'app.country.code',
                not: true,
                value: 'GB'
              }
            ]
          }
        },
        { type: 'masked-birthdate' },
        {
          type: 'multi-select.limits',
          params: {
            text: () => i18n.t('limits:limits_question.title'),
            modalOkButton: () => i18n.t('limits:modal_ok'),
            modalContent: () => i18n.t('limits:modal_content'),
            dispatchKey: 'updateUser',
            propertyName: 'gameLimits',
            hasInfo: true,
            currentAnswer: (store) => store.state.user.gameLimits,
            answers: () => ([
              { id: 'deposit_limit', label: i18n.t('limits:deposit_limit.amount.text') },
              { id: 'loss_limit', label: i18n.t('limits:loss_limit.amount.text') },
              { id: 'wager_limit', label: i18n.t('limits:wager_limit.amount.text') }
            ])
          }
        },
        {
          type: 'limits.deposit_limit',
          params: {
            text: () => i18n.t('limits:deposit_limit.amount.text'),
            dispatchKey: 'updateUser',
            propertyName: 'depositLimit',
            currentAnswer: (store) => store.state.user.depositLimit,
            conditions: [
              { property: 'user.gameLimits', includes: 'deposit_limit' }
            ]
          }
        },
        {
          type: 'limits.loss_limit',
          params: {
            text: () => i18n.t('limits:loss_limit.amount.text'),
            dispatchKey: 'updateUser',
            propertyName: 'lossLimit',
            currentAnswer: (store) => store.state.user.lossLimit,
            conditions: [
              { property: 'user.gameLimits', includes: 'loss_limit' }
            ]
          }
        },
        {
          type: 'limits.wager_limit',
          params: {
            text: () => i18n.t('limits:wager_limit.amount.text'),
            dispatchKey: 'updateUser',
            propertyName: 'wagerLimit',
            currentAnswer: (store) => store.state.user.wagerLimit,
            conditions: [
              { property: 'user.gameLimits', includes: 'wager_limit' }
            ]
          }
        },
        { type: 'phone-number-validation' },
        { type: 'GDPR',
          params: {
            screenTitle: () => i18n.t('overview:consent_header_title')
          }
        }
      ]
    }
  ])
}


module.exports = config



// WEBPACK FOOTER //
// ./src/partners/partner.module.config.js